import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './marketPlaceHeader.css';
const MarketplaceHeader = ({
  categories = [],
  activeCategory = '',
  onCategoryChange = () => {},
  searchValue = '',
  onSearchChange = () => {},
 
  cartCount: cartCountProp,
  favCount: favCountProp,
}) => {
  const [autoCartCount, setAutoCartCount] = useState(0);
  const [autoFavCount, setAutoFavCount] = useState(0);

  useEffect(() => {
    if (cartCountProp !== undefined && favCountProp !== undefined) return;
    const readCount = (key) => {
      try {
        const raw = localStorage.getItem(key);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr.length : 0;
      } catch {
        return 0;
      }
    };
    setAutoCartCount(readCount('mwg_cart'));
    setAutoFavCount(readCount('mwg_favorites'));
  }, [cartCountProp, favCountProp]);

  const cartCount = cartCountProp !== undefined ? cartCountProp : autoCartCount;
  const favCount = favCountProp !== undefined ? favCountProp : autoFavCount;

  return (
    <div className="mkt-header">
      {/* ── Barre utilitaire ── */}
      <div className="mkt-topbar">
      <Link  to="/dashboard" >
        <span className="mkt-logo">MWGTD</span>
        
        </Link>

        <div className="mkt-search">
          <span aria-hidden="true">🔍</span>
          <input
            type="text"
            placeholder="Rechercher un produit, une marque…"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Rechercher un produit"
          />
          {searchValue && (
            <button
              type="button"
              className="mkt-search-clear"
              onClick={() => onSearchChange('')}
              aria-label="Effacer la recherche"
            >
              ✕
            </button>
          )}
        </div>

        <div className="mkt-icons">
          <span className="mkt-ic" role="button" tabIndex={0} aria-label="Mon compte">👤</span>
          <span className="mkt-ic" role="button" tabIndex={0} aria-label="Mes favoris">
            ♡
            {favCount > 0 && <span className="mkt-badge">{favCount}</span>}
          </span>
          <span className="mkt-ic" role="button" tabIndex={0} aria-label="Mon panier">
            🛒
            {cartCount > 0 && <span className="mkt-badge">{cartCount}</span>}
          </span>
        </div>
      </div>

      {/* ── Barre de catégories ── */}
      <div className="mkt-catbar" role="tablist" aria-label="Catégories">
        <button
          type="button"
          className={`mkt-cat${activeCategory === '' ? ' on' : ''}`}
          role="tab"
          aria-selected={activeCategory === ''}
          onClick={() => onCategoryChange('')}
        >
          Toutes
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            type="button"
            className={`mkt-cat${activeCategory === cat ? ' on' : ''}`}
            role="tab"
            aria-selected={activeCategory === cat}
            onClick={() => onCategoryChange(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MarketplaceHeader;